/**
 * Import profile helpers shared by the profile editor and the import pages.
 * The matching here mirrors R-Point's gis-profile.service.js ruleMatches, so
 * the editor's preview shows what an import will do.
 */

export const MATCH_TYPES = [
  { value: "exact", label: "Name is" },
  { value: "contains", label: "Name contains" },
  { value: "regex", label: "Name matches pattern" },
];

export const PROFILE_ROLES = [
  { value: "dp_zones", label: "Zoning (filled colours)" },
  { value: "survey_parcels", label: "Survey parcels" },
  { value: "village_boundaries", label: "Village boundaries" },
  { value: "tp_plots", label: "TP plots" },
  { value: "roads", label: "Roads (centre lines)" },
  { value: "ignore", label: "Don't import" },
];

export const ROLE_LABEL = Object.fromEntries(PROFILE_ROLES.map((r) => [r.value, r.label]));

export function ruleMatches(rule, layerName) {
  const name = String(layerName || "");
  const value = String(rule.value || "");
  if (!value) return false;
  if (rule.match === "exact") return name.toLowerCase() === value.toLowerCase();
  if (rule.match === "contains") return name.toLowerCase().includes(value.toLowerCase());
  try {
    return new RegExp(value, "i").test(name);
  } catch {
    return false;
  }
}

/** The rule (and its index) that decides a layer, or null. First match wins. */
export function ruleFor(rules, layerName) {
  for (let i = 0; i < rules.length; i++) {
    if (ruleMatches(rules[i], layerName)) return { rule: rules[i], index: i };
  }
  return null;
}

export const DEFAULT_SETTINGS = {
  layer_rules: [],
  legend: [],
  labels: { village_font: null, survey_font: null, tp_font: "auto", survey_pattern: null },
  options: { dashed_gap_m: 6, village_min_area_sqm: 100000, min_unlabelled_area_sqm: 100, merge_zone_pieces: "auto", tp_gap_m: 0 },
  thresholds: { min_coded_pct: 95, min_numbered_pct: 70, max_rms_m: 20 },
};

export const fontToSize = (band) =>
  Array.isArray(band) ? String(Math.round(((Number(band[0]) + Number(band[1])) / 2) * 10) / 10) : "";
export const sizeToFont = (size) => (size === "" || size == null ? null : [Number(size) - 0.5, Number(size) + 0.5]);
